import React from "react";
import { Grid } from "@material-ui/core";
import { Controller, useWatch } from "react-hook-form";
import { EventNotification } from "../../domain/EventNotification";
import { SectionProps } from "./SectionProps";
import { Select } from "@ofqual/portal-components/components/Select";
import { riskCategoryService } from "../../services";
import { useLookup } from "@ofqual/portal-core/core/hooks";
import { fieldLabels } from "./fieldLabels";
import { Error } from "../common/Error";
import { useEffect } from "react";

export const Risk: React.FC<SectionProps<EventNotification>> = ({
  control,
  errors,
  disabled,
  lookupTracker,
  registerCustomError,
  trigger,
}) => {
  const { riskCategory } = useWatch({
    control,
    name: ["riskCategory"],
  });

  useEffect(() => {
    // Revalidate the form when the conditions change
    if (riskCategory !== null) {
      registerCustomError("riskCategory", false);
      trigger("riskCategory");
    }
  }, [trigger, riskCategory, registerCustomError]);

  const [riskCategoryLookup] = useLookup(riskCategoryService);
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Controller
          control={control}
          name="riskCategory"
          as={
            <Select
              label={fieldLabels.riskCategory}
              readOnly={disabled}
              datatest="risk-category"
              lookupTracker={lookupTracker}
            >
              {riskCategoryLookup}
            </Select>
          }
        />
        {errors.riskCategory && (
          <Error data-test="riskCategory-validation">
            This field is required
          </Error>
        )}
      </Grid>
    </Grid>
  );
};
